import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";

// formik components
import { Form } from "formik";
import Swal from "sweetalert2";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

import { Box, Button, CircularProgress, Dialog, Typography } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import { downloadTicketApi } from "api/tickets";
import { AuthContext } from "context/authContext";
import { downloadTicketApi2 } from "api/tickets";

// Import JSZip for creating ZIP files
import JSZip from "jszip";

function ReservationModal({ openModal, closeModal, openModalItemData }) {
    const { userRole } = useContext(AuthContext);

  useEffect(() => {
    getInitialValue();
  }, [openModalItemData]);

  const getInitialValue = () => {
    try {
      console.log("openModalItemData", openModalItemData)
    } catch (err) {
      console.log(err)
    }
  }

  const handleDownloadPdf = (id) => {
    try {
      if(userRole === "SuperAdmin") {
        const url = downloadTicketApi(id)
        window.open(url, '_blank')
      }
      else {
        const url = downloadTicketApi2(id)
        window.open(url, '_blank')
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  const handleDownloadAllPdfs = async () => {
    try {
      if (openModalItemData?.tickets && openModalItemData.tickets.length > 0) {
        // Show loading message
        Swal.fire({
          title: "Préparation du téléchargement",
          text: "Création du fichier ZIP en cours...",
          icon: "info",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const zip = new JSZip();
        const downloadPromises = [];

        // Create promises for each PDF download
        openModalItemData.tickets.forEach((ticket, index) => {
          const downloadPromise = new Promise(async (resolve, reject) => {
            try {
              let url;
              if(userRole === "SuperAdmin") {
                url = downloadTicketApi(ticket._id);
              } else {
                url = downloadTicketApi2(ticket._id);
              }

              // Fetch the PDF
              const response = await fetch(url);
              if (!response.ok) {
                throw new Error(`Failed to fetch PDF for ticket ${ticket._id}`);
              }

              const pdfBlob = await response.blob();
              
              // Add to ZIP with a descriptive filename
              const fileName = `Ticket_${index + 1}_${ticket?.eventID?.eventTitle || 'Event'}.pdf`;
              zip.file(fileName, pdfBlob);
              
              resolve();
            } catch (error) {
              console.error(`Error downloading PDF for ticket ${ticket._id}:`, error);
              reject(error);
            }
          });

          downloadPromises.push(downloadPromise);
        });

        // Wait for all PDFs to be downloaded
        await Promise.all(downloadPromises);

        // Generate and download the ZIP file
        const zipBlob = await zip.generateAsync({ type: "blob" });
        
        // Create download link
        const downloadUrl = URL.createObjectURL(zipBlob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `Tickets_${openModalItemData.tickets.length}_PDFs.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up
        URL.revokeObjectURL(downloadUrl);

        // Close loading and show success
        Swal.fire({
          title: "Téléchargement terminé",
          text: `Le fichier ZIP contenant ${openModalItemData.tickets.length} PDF(s) a été téléchargé`,
          icon: "success",
        });
      }
    }
    catch (err) {
      console.log(err);
      Swal.fire({
        title: "Erreur",
        text: "Une erreur est survenue lors du téléchargement",
        icon: "error",
      });
    }
  }

  return (
    <div>
      <Dialog open={openModal} onClose={closeModal} fullWidth maxWidth="sm">
        <MDBox style={{ height: '80vh', overflow: 'auto' }}>
          {/* Download All PDFs Button */}
          {openModalItemData?.tickets && openModalItemData.tickets.length > 1 && (
            <MDBox style={{ padding: '20px', textAlign: 'center', borderBottom: '1px solid #eee' }}>
              <MDButton 
                variant="gradient" 
                color="success" 
                onClick={handleDownloadAllPdfs}
                startIcon={<span>📄</span>}
              >
                Télécharger tous les PDFs ({openModalItemData.tickets.length})
              </MDButton>
            </MDBox>
          )}
          
          <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
            {
              openModalItemData?.tickets?.map((el, index) => (
                <Grid item xs={12}>
                  <MDBox style={{ padding: '10px' }}>
                    <DefaultInfoCard
                      icon="confirmation_number"
                      title={`${el?.eventID?.eventTitle}`}
                      description={`Ticket (${index+1})`}
                      value={`${el?.price} MAD`}
                    />
                  </MDBox>
                  <MDBox item xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <MDButton variant="gradient" color="info" onClick={() => handleDownloadPdf(el._id)}>Télécharger PDF</MDButton>
                  </MDBox>
                </Grid>
              ))
            }
          </Grid>
        </MDBox>
      </Dialog>
    </div>
  );
}

ReservationModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ReservationModal;
